import { StyleSheet } from 'react-native';
import { checkIsPlatform, tokens, LILAC_200, BLACK_500, BLACK_900, BLACK_700, LILAC_700 } from '@airtel/air-design-system';
export var getCompareBenefitItemV2Styles = (props, isLargeScreen) => {
  var roundedCorners = props.roundedCorners,
    noPressEffect = props.noPressEffect,
    disabled = props.disabled,
    showBenefitIconTop = props.showBenefitIconTop;
  var _tokens$spacing = tokens.spacing,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_4 = _tokens$spacing.SPACING_4,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_24 = _tokens$spacing.SPACING_24,
    SPACING_28 = _tokens$spacing.SPACING_28,
    SPACING_32 = _tokens$spacing.SPACING_32,
    SPACING_0 = _tokens$spacing.SPACING_0,
    SPACING_1 = _tokens$spacing.SPACING_1;
  var BORDER_RADIUS_4 = tokens.borderRadius.BORDER_RADIUS_4;
  return StyleSheet.create({
    compareBenefitItemContainer: Object.assign(Object.assign(Object.assign({
      flexDirection: 'row',
      width: '100%'
    }, !showBenefitIconTop && {
      alignItems: 'center'
    }), {
      backgroundColor: LILAC_200,
      borderRadius: roundedCorners ? SPACING_12 : SPACING_0,
      marginVertical: SPACING_8
    }), noPressEffect && checkIsPlatform('web') && {
      cursor: 'default'
    }),
    container: {
      flex: 1,
      flexDirection: 'column',
      marginRight: SPACING_12
    },
    centerContainer: {
      justifyContent: 'center',
      alignItems: 'center'
    },
    avatarStyles: {
      height: isLargeScreen ? SPACING_32 : SPACING_28,
      width: isLargeScreen ? SPACING_32 : SPACING_28,
      marginRight: SPACING_8,
      borderRadius: BORDER_RADIUS_4
    },
    headerText: {
      color: disabled ? BLACK_500 : BLACK_900,
      marginRight: SPACING_24
    },
    subHeaderText: {
      color: disabled ? BLACK_500 : BLACK_700
    },
    infoTag: {
      marginTop: SPACING_4
    },
    spacerContainer: {
      width: '100%',
      height: SPACING_1,
      backgroundColor: LILAC_700
    }
  });
};